<template>
    <input type="password" autocomplete="new-password" v-if="isNew || editMode" :value="value" @change="$emit('change', $event.target.value)" @blur="onBlur"/>
    <input type="text" v-else-if="tcknIncorrect && isEntered" :placeholder="translate('errors.tcknShouldBe11')" @focus="editMode = true" />
    <input type="text" v-else-if="isIdentityDefined || isEntered" :placeholder="translate('messages.tcknEntered')" @focus="editMode = true" class="is-valid" />
    <input type="text" v-else :placeholder="translate('messages.clickToEnterTckn')" @focus="editMode = true" />
</template>
<script>
export default {
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        value: {
            type:String
        },
        idDefined: Boolean,
        required: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return {
            editMode: false,
            tcknIncorrect: false,
        }
    },
    methods: {
        onBlur($event){
            console.log('onBlur', $event);
            this.$emit('change', $event.target.value);
            this.editMode = false;
        }
    },
    created(){
        console.log(this.isIdentityDefined)
    },
    watch: {
        value(oldValue){
            if(oldValue.length != 11 && oldValue.length != 0){
                this.tcknIncorrect = true
            }else{
                this.tcknIncorrect = false
            }
        }
    },
    computed:{
        isIdentityDefined(){
            return this.idDefined == true
        },
        isNew(){
            // Sadece null ise yeni giriştir. Empty String, daha önce parola gilirmiş ancak server'dan client'e dönülmemiş demektir.
            return this.value == null && this.idDefined == false;
        },
        isEntered(){
            return this.value != null && this.value != '';
        }
    }
}
</script>
